import { API_URL_V3 } from 'constants/config';
import { fetch } from 'services/apiV3/fetch';

type OrderExpirationResponse = {
  dueAt: string;
};

const orderExpirationService = {
  fetch: (orderId: string, token: string) =>
    fetch(
      `${API_URL_V3}/orders/${orderId}/expiration_date?token=${encodeURIComponent(token)}`,
      { method: 'GET' },
    ) as Promise<OrderExpirationResponse>,
};

export { type OrderExpirationResponse, orderExpirationService };
